"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toAbsoluteVector2d = exports.toRelativeVector2d = exports.toAbsolutePos = exports.toRelativePos = exports.toAbsoluteRectSize = exports.toRelativeRectSize = exports.toAbsoluteRect = exports.toRelativeRect = void 0;
/**
 *
 * ```
 * +----------------+  --- n
 * |                |
 * |   +-------+    |  --- y
 * |   |       |    |
 * |   +-------+    |
 * +----------------+  --- s
 *
 * r = (y - n)/(s - n)  (toRelative)
 * y = r(s - n) + n     (toAbsolute)
 * ```
 */
var toRelativeRect = function (baseRect) { return function (rectAbsolute) {
    return rectAbsolute.withMutations(function (from) {
        return from
            .update('top', function (t) { return (t - baseRect.top) / baseRect.height; })
            .update('left', function (l) { return (l - baseRect.left) / baseRect.width; })
            .update('width', function (w) { return w / baseRect.width; })
            .update('height', function (h) { return h / baseRect.height; });
    });
}; };
exports.toRelativeRect = toRelativeRect;
var toAbsoluteRect = function (baseRect) { return function (rectRelative) {
    return rectRelative.withMutations(function (from) {
        return from
            .update('top', function (t) { return t * baseRect.height + baseRect.top; })
            .update('left', function (l) { return l * baseRect.width + baseRect.left; })
            .update('width', function (w) { return w * baseRect.width; })
            .update('height', function (h) { return h * baseRect.height; });
    });
}; };
exports.toAbsoluteRect = toAbsoluteRect;
var toRelativeRectSize = function (baseRect) { return function (rectSizeAbsolute) {
    return rectSizeAbsolute.withMutations(function (from) {
        return from
            .update('width', function (w) { return w / baseRect.width; })
            .update('height', function (h) { return h / baseRect.height; });
    });
}; };
exports.toRelativeRectSize = toRelativeRectSize;
var toAbsoluteRectSize = function (baseRect) { return function (rectSizeRelative) {
    return rectSizeRelative.withMutations(function (from) {
        return from
            .update('width', function (w) { return w * baseRect.width; })
            .update('height', function (h) { return h * baseRect.height; });
    });
}; };
exports.toAbsoluteRectSize = toAbsoluteRectSize;
var toRelativePos = function (baseRect) { return function (posAbsolute) {
    return posAbsolute.withMutations(function (from) {
        return from
            .update('x', function (x) { return (x - baseRect.left) / baseRect.width; })
            .update('y', function (y) { return (y - baseRect.top) / baseRect.height; });
    });
}; };
exports.toRelativePos = toRelativePos;
var toAbsolutePos = function (baseRect) { return function (posRelative) {
    return posRelative.withMutations(function (from) {
        return from
            .update('x', function (x) { return x * baseRect.width + baseRect.left; })
            .update('y', function (y) { return y * baseRect.height + baseRect.top; });
    });
}; };
exports.toAbsolutePos = toAbsolutePos;
var toRelativeVector2d = function (baseRect) { return function (vectAbsolute) {
    return vectAbsolute.withMutations(function (from) {
        return from
            .update('x', function (x) { return x / baseRect.width; })
            .update('y', function (y) { return y / baseRect.height; });
    });
}; };
exports.toRelativeVector2d = toRelativeVector2d;
var toAbsoluteVector2d = function (baseRect) { return function (vectRelative) {
    return vectRelative.withMutations(function (from) {
        return from
            .update('x', function (x) { return x * baseRect.width; })
            .update('y', function (y) { return y * baseRect.height; });
    });
}; };
exports.toAbsoluteVector2d = toAbsoluteVector2d;
